
import React from "react";

export default function Video ({ className, color }) {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.722 7.521C20.089 7.181 19.321 7.21699 18.721 7.61499L15.711 9.61499C15.511 7.17799 13.487 5.25 11 5.25H7C4.381 5.25 2.25 7.381 2.25 10V14C2.25 16.619 4.381 18.75 7 18.75H11C13.487 18.75 15.511 16.822 15.711 14.385L18.721 16.386C19.048 16.602 19.423 16.712 19.8 16.712C20.116 16.712 20.433 16.635 20.722 16.48C21.356 16.14 21.75 15.481 21.75 14.762V9.23901C21.75 8.51901 21.356 7.861 20.722 7.521ZM14.25 14.001C14.25 15.793 12.792 17.251 11 17.251H7C5.208 17.251 3.75 15.793 3.75 14.001V10.001C3.75 8.20898 5.208 6.75098 7 6.75098H11C12.792 6.75098 14.25 8.20898 14.25 10.001V14.001ZM20.25 14.762C20.25 15.005 20.084 15.12 20.013 15.158C19.941 15.197 19.755 15.27 19.551 15.137L15.75 12.611V11.39L19.551 8.86401C19.755 8.72901 19.942 8.80392 20.013 8.84192C20.084 8.87992 20.25 8.99504 20.25 9.23804V14.762Z"
        fill={(color)||"#6F6C99"}
      />
    </svg>
  );
};